<template>
<div id="modals">
  <section class="popup popup-thanks is-active" v-if="requestModal === 1">
    <div class="popup__wrapper">
      <div class="popup__inner">
        <div class="popup__content-thanks" style="max-width: 63vw;">
          <div class="popup__content__bg">
            <button class="popup__btn popup__btn-close popup-close" @click="requestModal=0" type="button"></button>
            <div class="thanks-content">
              <div class="thanks-content__text" v-html="$root.modalText">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="popup popup-thanks is-active" v-if="requestModal === 2">
    <div class="popup__wrapper">
      <div class="popup__inner">
        <div class="popup__content-thanks" style="max-width: 480px;">
          <div class="popup__content__bg" style="">
            <button class="popup__btn popup__btn-close popup-close" @click="requestModal=0" type="button"></button>
            <div class="thanks-content__close-tabs">
              <div class="selects">
                <div class="nice-select__close-tabs date" style="margin-bottom: 10px" tabindex="0"><span class="current">Получите консультацию и персональные условия</span></div>
                <div class="nice-select__close-tabs_sub subject" tabindex="0"><span class="current">Наш юрист поможет с выбором варианта решения и<br/>ответит на все вопросы о процессе обучения</span></div>
              </div>
              <div class="thanks-content__text">
                <div class="thanks-content__text-wrapper">
                  <input type="text" class="popup-form__input" placeholder=" Ваше Имя" v-model="name">
                  <input type="text" class="popup-form__input" placeholder=" +7(___)___ - __ - __" data-inputmask="'mask': '+7(999)999-99-99'"  v-model="phone">
                  <input type="text" class="popup-form__input" placeholder=" E-mail" data-inputmask="'alias': 'email'" v-model="email">
                  <button class="popup-form__btn" id="next1" @click="sendDocsCloseTabs">Получить бесплатную консультацию</button>
                  <p class="conf">Все данные защищены</p>
                </div>
                <span class="popup-form__img"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section v-if="requestModal < 0">
    <link rel="stylesheet" href="/static/css/index3-style.css">
    <div class="window" v-if="modal">
      <div class="date-div">
        <input type="date" class="date-inp" placeholder=" Дата" v-model="date">
        <input type="time" class="time-inp" placeholder=" Время" v-model="time">
      </div>
      <div class="select-div">
        <div class="dropdown my-drop">
          <button class="btn-light btn dropdown-toggle" type="button" id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false" style="white-space: unset;position: relative;">{{text}}
            <img class="my-dropdown" src="/static/img/dr-icon.png" alt="">
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item"  v-for="situation in situations" :key="situation.id" @click="text = situation.name">{{situation.name}}</a>
          </div>
        </div>
      </div>
      <div class="inputs">
        <div class="input-div">
          <input type="text" class="new-input" placeholder=" Ваше Имя" v-model="name">
          <input type="text" class="new-input" placeholder=" Город" v-model="city">
          <input type="text" class="new-input" placeholder=" +7(___)___ - __ - __" data-inputmask="'mask': '+7(999)999-99-99'"  v-model="phone">
          <input type="text" class="new-input" placeholder=" E - mail" data-inputmask="'alias': 'email'" v-model="email">
        </div>
        <div class="img-div">
          <img src="/static/img/code.png" alt="">
        </div>
      </div>
      <input type="submit" class="send-btn t" value="Получить документы для суда " @click="sendDocs">
      <br>
      <br>
      <div class="text-div">
        <b class="index-3-text-1">Оплатите 249 рублей онлайн с любого банка по QR коду. Сканируйте его в
          Сбербанк Онлайн или другом банке.
          или перейдите на сайт платежной системы банка. Все платежи защищены.</b>
        <p class="index-3-text-2">
          1. После оплаты бухгалтерия самостоятельно произведет зачисление платежа. Квитанция
          не требуется.
          <br>
          2. Вам на почту придет подтверждение регистрации, а за час до начала разбора Вашего
          дела доступы в онлайн-кабинет.
          Возникли вопросы? Звоните по бесплатному номеру 8800000001
        </p>
      </div>
    </div>
    <div class="container th-container text-center" v-if="send">
      <div class="th-text">
        СПАСИБО!
        <br>
        Ваша заявка принята, проверьте
        <br>
        свою электронную почту.
      </div>
      <button class="send-btn-2" @click="send = 0">ОК</button>
    </div>
  </section>
</div>
</template>

<script>
import axios from '@/router/http'
import Inputmask from 'inputmask'
export default {
    name: 'modals',
    props: ['user', 'requestModal'],
    data () {
        return {
            modal: 1,
            send: 0,
            text: 'Выберите статью',
            situations: [],
            date: null,
            time: null,
            name: null,
            city: null,
            phone: null,
            email: null
        }
    },
    created () {
        Inputmask().mask(document.querySelectorAll('input'))

        const today = new Date()
        let y = today.getFullYear()
        let m = (today.getMonth() + 1)
        let d = today.getDate()
        let h = today.getHours()
        let i = today.getMinutes()
        if (y < 10) y = '0' + y
        if (m < 10) m = '0' + m
        if (d < 10) d = '0' + d
        if (h < 10) h = '0' + h
        if (i < 10) i = '0' + i
        this.date = y + '-' + m + '-' + d
        this.time = h + ':' + i
    },
    mounted () {
        axios.get('https://urist1.v-avtoservice.com/list/get-lists?id=6').then(response => {
            this.situations = response.data
        })
        Inputmask().mask(document.querySelectorAll('input'))
    },
    methods: {
        sendDocs () {
            if (!this.text || this.text === 'Выберите статью') alert('Вам необходимо выбрать статью')
            else if (!this.date) alert('Вам необходимо указать дату жалообы')
            else if (!this.time) alert('Вам необходимо указать время жалообы')
            else if (!this.name) alert('Вам необходимо указать как вас зовут')
            else if (!this.city) alert('Вам необходимо указать город')
            else if (!this.phone) alert('Вам необходимо указать телефон')
            else if (!this.email) alert('Вам необходимо указать email')
            else {
                this.$root.outsideModal = -1
                this.send = 1
                this.modal = 0
                var formData = new FormData()
                formData.append('crm', '9')
                formData.append('pipe', '17')
                formData.append('contact[name]', this.name)
                formData.append('contact[141]', this.phone)
                formData.append('contact[142]', this.email)
                formData.append('contact[143]', this.city)
                formData.append('contact[144]', this.user.uid)
                formData.append('lead[145]', this.text)
                formData.append('lead[146]', this.date + ' ' + this.time)
                formData.append('lead[147]', this.city)
                formData.append('lead[148]', this.user.uid)
                axios.post('https://urist1.v-avtoservice.com/api/import-lead',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(res => {
                  if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
                  else alert('Спасибо, ваша заявка отправлена')
                })
            }
        },
        sendDocsCloseTabs () {
          if (!this.name) alert('Вам необходимо указать как вас зовут')
          else if (!this.phone) alert('Вам необходимо указать телефон')
          else if (!this.email) alert('Вам необходимо указать email')
          else {
            this.requestModal = 0
            let formDataUrist = new FormData()
            formDataUrist.append('crm', '11')
            formDataUrist.append('pipe', '22')
            formDataUrist.append('contact[name]', this.name)
            formDataUrist.append('contact[199]', this.phone)
            formDataUrist.append('contact[200]', this.email)
            axios.post('https://urist.v-avtoservice.com/api/import-lead',
              formDataUrist,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
            ).then(res => {
              if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
              else alert('Спасибо, ваша заявка отправлена')
            })
            let formData = new FormData()
            formData.append('crm', '9')
            formData.append('pipe', '17')
            formData.append('contact[name]', this.name)
            formData.append('contact[141]', this.phone)
            formData.append('contact[142]', this.email)
            formData.append('lead[146]', 'Консультация с без-юриста')
            formData.append('lead[145]', 'Консультация с без-юриста')
            formData.append('note', 'Консультация с без-юриста')
            axios.post('https://urist1.v-avtoservice.com/api/import-lead',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
            ).then(res => {
              if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
              else alert('Спасибо, ваша заявка отправлена')
            })
          }
        }
    }
}
</script>

<style scoped>
#modals > div {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background: white;
}
.thanks-content__close-tabs {
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
.popup-form__img {
  background-image: url("../../../static/img/popup/close_tabs.svg");
  width: 90px;
  height: 143px;
}
.nice-select__close-tabs {
  font-size: 26px;
  font-weight: 700;
}
.nice-select__close-tabs_sub {
  font-size: 14px;
  opacity: .6;
  font-weight: 500;
  margin-bottom: 20px;
}
.thanks-content__text {
  display: flex;
  width: 100%;
}
.thanks-content__text-wrapper{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 75%;
  margin-right: 15px;
}
.popup-form__input {
  border: 1px solid rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  background-color: #ffffff;
  color: rgba(0, 0, 0, 0.5);
  font-family: "Montserrat";
  font-size: 14px;
  font-weight: 400;
  padding: 10px 15px 11px;
  margin-bottom: 15px;
  width: 100%;
}
.popup-form__input:focus {
  border-color: #f6a913 !important;
}
.popup-form__btn {
  cursor: pointer;
  border-radius: 6px;
  color: #ffffff;
  max-width: 280px;
  background: -webkit-gradient(linear, left top, left bottom, from(#83E673), to(#5CAD4F));
  background: -o-linear-gradient(top, #83E673 0%, #5CAD4F 100%);
  background: linear-gradient(180deg, #83E673 0%, #5CAD4F 100%);
  padding: 10px 13px;
  margin-bottom: 10px;
}
  .conf {
    font-size: 12px;
    opacity: .6;
  }
</style>



// WEBPACK FOOTER //
// src/components/include/modals.vue